import { withTranslation } from 'react-i18next';
import { BaseNodeComponent, PropsWithContext } from '@jsplumbtoolkit/browser-ui-react';

import { classnames } from 'lib/classnames';
import { NodeProps } from 'lib/types/workflow';

import Port from './Port';

import styles from './index.module.less';

const cx = classnames(styles);
interface StartNodeProps {
  setSelected?: (id: string, selected: boolean) => void;
  updateNodePosition: (id: string, position: number[]) => void;
  viewer?: boolean;
  data: NodeProps;
  t: any;
}

const anchors = ['Right', 'Bottom'];

class StartNode extends BaseNodeComponent<StartNodeProps & PropsWithContext, Record<string, never>> {
  selected: boolean;
  bgColor: string;
  constructor(props: StartNodeProps & PropsWithContext) {
    super(props);
  }

  selectHandle = (selected: boolean): void => {
    this.selected = selected;
  };

  render(): React.ReactElement {
    const { t } = this.props;
    return (
      <div
        id={this.props.data.id}
        onClick={() => this.selectHandle(true)}
        className={cx('flow-node', 'node-start', {
          'view-node': this.props.viewer,
        })}
      >
        <div className={cx('node-content')}>{t('pages.workflow.default.startNodeName')}</div>
        {anchors.map(item => {
          return (
            <Port
              key={item}
              node={this.props.data}
              type={item}
              toolkit={this.toolkit}
              surface={this.surface}
              vertex={this.vertex}
            />
          );
        })}
      </div>
    );
  }
}

export default withTranslation()(StartNode);
